import { createSvgComponent } from "../../icon/createSvgComponent";
import Welmarket from "@core/icon/assets/welmarket.svg";
export default createSvgComponent(Welmarket);